import { isString, reduce, values } from 'lodash-es';

import { isArrayOfStrings, isObject } from '@utils/guards';

export default function getValidationErrorMessages(errors: unknown, prevResult: string[] = []): string[] {
  const result: string[] = [...prevResult];

  if (isArrayOfStrings(errors)) {
    return [...result, ...errors];
  }

  if (isString(errors)) {
    return [...result, errors];
  }

  if (!isObject(errors)) {
    return result;
  }

  return reduce(values(errors), (acc, value) => {
    if (isArrayOfStrings(value)) {
      return [...acc, ...value];
    }

    if (isString(value)) {
      return [...acc, value];
    }

    if (isObject(value) && 'values' in value && 'locale_key' in value) {
      return getValidationErrorMessages(value.locale_key, acc);
    }

    return getValidationErrorMessages(value, acc);
  }, result);
}
